export const Segmented = ({ label, value, options, onChange, testId, hint }) => (
  <div data-testid={testId}>
    <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#52525B]">{label}</span>
    <div className="mt-2 grid gap-1 border border-black/15 bg-white" style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          data-testid={`${testId}-${o.value}`}
          className={`text-[11px] uppercase tracking-[0.15em] font-bold py-2 transition-colors duration-200 ${
            value === o.value ? "bg-[#0A0A0B] text-white" : "bg-white text-[#52525B] hover:text-[#0A0A0B]"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
    {hint && <p className="text-xs text-[#52525B] mt-2 leading-relaxed">{hint}</p>}
  </div>
);
